import React from 'react'; 
import { Link } from 'react-router-dom';

import TableRows from '../../components/Skeletons/TableRows';

export default function ShowData({ data,  pageNumber, pageLimit, loading }) { 

	const { showFilter, quizResultsList } = data;

	return (
		<div className='tableContainer' style={{ height: showFilter ? '63vh' : '23vh' }}>
			<table className='table'>
				<thead>
					<tr>
						<th>#</th>
						<th>Provider</th>
						<th>Clinic Name</th>
						<th>Email</th>
						<th>User F/L Name</th>
						<th>Birth Date</th>
						<th>Postive Responders</th>
						<th style={{ textAlign: 'center' }}>View Results</th>

					</tr>
				</thead>
				<tbody>
					{quizResultsList && !loading ? quizResultsList?.length > 0 ? (
						quizResultsList?.map((user, index) => (
							<tr key={index + 1}>
                                <td>{(pageNumber - 1) * pageLimit + (index + 1)}</td>						
								<td style={{ textAlign: 'left' }}>{user.providerName}</td>
								<td>{user.clinicName}</td>
								<td>{user.email}</td>
								<td>{user.patientFirstName + ' ' + user.patientLastName}</td>
								<td>
									{new Date(user.birthDate).toLocaleDateString('en-US', {
										year: 'numeric',
										month: '2-digit',
										day: '2-digit'
									})}
								</td>

								<td>
									{Object.keys(user)
										.filter(key => key.startsWith("quizResult_Data_"))
										.map(key => {
											const data = user[key];
											return data && data.productName ? data.productName : null;
										  })
										  .filter(productName => productName !== null)
										  .join(" , ")
										}
								</td>
								<td>
									<span className='table__iconBox' style={{ justifyContent: 'center' }}> 
										<Link to={`/pdfView/${user.currentAssessmentResultId}`} className='table__button2'>
											<svg className='table__icon primary-icon' style={{ width: '2rem', height: '2rem' }}>
												<use xlinkHref={`/sprite.svg#icon-pdf`} />
											</svg>
											<span>View</span>
										</Link>
									</span>
								</td> 
							</tr>
						))
					) : (
						<tr>
							<td colSpan='13' style={{ textAlign: 'center', padding: '2rem' }}>
								There are no quiz results to show.
							</td>
						</tr>
					) : (
						<TableRows columns='13' />
					)}
				</tbody>
			</table>
		</div>
	);
}
